import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, Users, BadgeCheck, CreditCard, Heart, MessageSquare, BarChart3, Settings, Database, LogOut, ChevronDown, X, } from "lucide-react";
const superAdminMenu = [
    {
        title: "Dashboard",
        icon: LayoutDashboard,
        path: "/super-admin/dashboard",
    },
    {
        title: "Branches",
        icon: Building2,
        path: "/super-admin/branches",
    },
    {
        title: "Members",
        icon: Users,
        path: "/super-admin/members",
    },
    {
        title: "Membership Plans",
        icon: CreditCard,
        path: "/super-admin/membership-plans",
    },
    {
        title: "Payments",
        icon: CreditCard,
        path: "/super-admin/payments",
    },
    // {
    //     title: "Matches",
    //     icon: Heart,
    //     path: "/super-admin/matches",
    // },
    {
        title: "Enquiries",
        icon: MessageSquare,
        path: "/super-admin/enquiries",
    },
    {
        title: "Reports",
        icon: BarChart3,
        path: "/super-admin/reports",
    },
];

const branchAdminMenu = [
    {
        title: "Dashboard",
        icon: LayoutDashboard,
        path: "/branch/dashboard",
    },
    {
        title: "Members",
        icon: Users,
        path: "/branch/members",
    },
    {
        title: "Profile Verification",
        icon: BadgeCheck,
        path: "/branch/profile-verification",
    },
    {
        title: "Matches",
        icon: Heart,
        path: "/branch/matches",
    },
    // {
    //     title: "Enquiries",
    //     icon: MessageSquare,
    //     path: "/branch/enquiries",
    // },
    {
        title: "Wallets",
        icon: CreditCard,
        path: "/branch/wallets",
    },
    {
        title: "Reports",
        icon: BarChart3,
        path: "/branch/reports",
    },
];

function Sidebar({ mobileOpen, setMobileOpen }) {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const role = localStorage.getItem("jodiPointRole");
    const isSuperAdmin = role === "SUPER_ADMIN";
    const menuItems = isSuperAdmin
        ? superAdminMenu
        : branchAdminMenu;
    const roleName = isSuperAdmin
        ? "Super Administrator"
        : "Branch Administrator";
    const handleLogout = () => {
        setShowLogoutModal(true);
    };
    const confirmLogout = () => {
        localStorage.removeItem("jodiPointRole");
        localStorage.removeItem("jodiPointUser");
        setShowLogoutModal(false);
        navigate("/login", { replace: true, });
    };
    const cancelLogout = () => {
        setShowLogoutModal(false);
    };
    return (
        <>
            {mobileOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setMobileOpen(false)}
                />
            )}
            <aside className={`admin-sidebar ${mobileOpen ? "sidebar-open" : ""}`}>
                <div className="sidebar-logo">
                    <img src="/logo.png" alt="Jodi Point" />
                    <button className="sidebar-close" onClick={() => setMobileOpen(false)}>
                        <X size={22} />
                    </button>
                </div>
                <div className="sidebar-role">
                    <div className="role-icon">
                        {isSuperAdmin ? (
                            <Database size={17} />
                        ) : (
                            <Building2 size={17} />
                        )}
                    </div>
                    <div>
                        <span>Logged in as</span>
                        <strong>{roleName}</strong>
                    </div>
                    <ChevronDown size={15} />
                </div>
                <div className="sidebar-content">
                    <div className="menu-title">MAIN MENU</div>
                    <nav className="sidebar-menu">
                        {menuItems.map((item) => {
                            const Icon = item.icon;
                            return (
                                <NavLink key={item.path} to={item.path} className={({ isActive }) => `sidebar-link 
                                ${isActive ? "active" : ""}`} onClick={() => setMobileOpen(false)}>
                                    <Icon size={19} />
                                    <span>{item.title}</span>
                                </NavLink>
                            );
                        })}
                    </nav>
                    {isSuperAdmin && (
                        <>
                            <div className="menu-title master-title">MANAGEMENT</div>
                            <NavLink to="/super-admin/masters" className={({ isActive }) => `sidebar-link 
                            ${isActive ? "active" : ""}`} onClick={() => setMobileOpen(false)}>
                                <Database size={19} />
                                <span>Masters</span>
                            </NavLink>
                            <NavLink to="/super-admin/settings" className={({ isActive }) => `sidebar-link 
                            ${isActive ? "active" : ""}`} onClick={() => setMobileOpen(false)}>
                                <Settings size={19} />
                                <span>Settings</span>
                            </NavLink>
                        </>
                    )}
                </div>
                <div className="sidebar-bottom">
                    <button className="logout-button" onClick={handleLogout}>
                        <LogOut size={19} />
                        <span>Logout</span>
                    </button>
                </div>
                {showLogoutModal && (
                    <div className="logout-modal-overlay">
                        <div className="logout-modal">
                            <div className="logout-modal-icon">
                                <LogOut size={25} />
                            </div>
                            <h3>Logout Confirmation</h3>
                            <p>Are you sure you want to logout from Jodi Point Admin?</p>
                            <div className="logout-modal-actions">
                                <button className="logout-cancel-btn" onClick={cancelLogout}>Cancel</button>
                                <button className="logout-confirm-btn" onClick={confirmLogout}>Logout</button>
                            </div>
                        </div>
                    </div>
                )}
            </aside>
        </>
    );
}

export default Sidebar;